import React, { useEffect, useMemo, useState } from "react";
import { Tooltip } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import dayjs from "dayjs";
import moment from "moment";
import { useSetLoading } from "../../../../../common/hooks/appearance";
import ownerImage from "../../../../../assets/icons/userProfileIcone.png";
import CompanyDashboardInitiativeDrawerSideBarDescription from "./company-dashboard-initiative-drawer-side-bar-description";
import CompanyDashboardInitiativeDrawerSideBarDepartment from "./company-dashboard-initiative-drawer-side-bar-department";
import CompanyDashboardInitiativeDrawerSideBarRole from "./company-dashboard-initiative-drawer-side-bar-role";
import CompanyDashboardInitiativeDrawerSideBarName from "./company-dashboard-initiative-drawer-side-bar-name";
import CompanyDashboardInitiativeDrawerSideBarTimeline from "./company-dashboard-initiative-drawer-side-bar-timeline";
import CompanyDashboardInitiativeDrawerSideBarKeyResults from "./company-dashboard-initiative-drawer-side-bar-key-results";
import CompanyDashboardInitiativeDrawerSideBarObjectives from "./company-dashboard-initiative-drawer-side-bar-objectives";
import { addInitiative, updateInitiative } from "../../../../../api/initiative";
import { getAllMilestones } from "../../../../../api/milestones";
import { OverlayScrollbarsComponent } from "overlayscrollbars-react";
import { getKeyResults } from "../../../../../api/search-dashboard";
import "./company-dashboard-initiative-drawer-side-bar.scss";
import { usePermissions } from "../../../../../common/hooks/usePermissions";
import MODULES from "../../../../../constants/modules";
import Department from "../../../../departments/departments";
import Status from "../../../../request-dashboard/request/status/status";

const CompanyDashboardInitiativeDrawerSideBar: any = (props: any) => {// NOSONAR
  const {
    employeesList,
    initiativeId,
    setInitiativeId,
    setAlertType,
    setAlertOpen,
    // setLoading,
    objectiveId,
    setObjectiveId,
    setAlertMessage,
    keyResultId,
    setKeyResultId,
    fetchInitiatives,
    statusListKeyResults,
    statusListObjectives,
    statusListInitiatives,
    fetchInitiativeById,
    initiativeAPIData,
    setObjective,
    setIsShowInitiativeDrawer,
    setIsShowAddAllObjectiveDrawer,
    departmentsList,
    setMilestonesData,
    clearedMilestonesData,
    initiativeDataPermissions,
  } = props;
  const activeTabClassName =
    "company-dashboard-initiative-drawer-side-bar-content-inner-tab-action-button-active";

  const keyResultIdTooltip = keyResultId
    ? ""
    : "Please create a Key Result before adding an Initiative";

  const objectiveIdTooltip = true
    ? ""
    : "Please create an Objective before adding an Key Result";

  const initiativeIdTooltip = initiativeId ? "" : "Add an Initiative";

  const userID = JSON.parse(
    localStorage.getItem("userDetails") || "{}",
  )?.employeeId;

  const dateFormat = "YYYY-MM-DD";

  const subDepartmentList = [
    { color: "#FCE8D2", text: "Sales", id: [1, 11, 21, 31, 41, 51] },
    { color: "#D6ECD2", text: "Marketing", id: [2, 12, 22, 32, 42, 52] },
    { color: "#FFD9E7", text: "AI Team", id: [3, 13, 23, 33, 43, 53] },
    { color: "#DEC3A6", text: "Finance", id: [4, 14, 24, 34, 44, 54] },
    { color: "#DDEAFF", text: "Accounting", id: [5, 15, 25, 35, 45, 55] },
    { color: "#CAC3D6", text: "IT", id: [6, 16, 26, 36, 46, 56] },
    {
      color: "#C3E0DF",
      text: "Engineering & Transformation",
      id: [7, 17, 27, 37, 47, 57],
    },
    { color: "#BAD1B6", text: "PMO", id: [8, 18, 28, 38, 48, 58] },
    { color: "#FFFDD9", text: "Data", id: [9, 19, 29, 39, 49, 59] },
    {
      color: "#E0C3CE",
      text: "Technology and Data",
      id: [10, 20, 30, 40, 50, 60],
    },
  ];
  const osRef: any = React.useRef<any>(null);
  const [mainDepartmentList, setMainDepartmentList] = useState<any>([]);
  const [isAccordion, setIsAccordion] = useState(!!initiativeId);
  const [isActiveTab, setIsActiveTab] = useState(false);
  const [newObjectiveData, setNewObjectiveData] = useState<any>([]);
  const [detailsData, setDetailsData] = useState<any>(null);
  const [description, setDescription] = useState("");
  const [selectedAddedRole, setSelectedAddedRole] = useState<any>([]);
  const [listKeyResultsData, setListKeyResultsData] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [keyResultsLoading, setKeyResultsLoading] = useState(false);
  const [timelineData, setTimelineData] = useState<any>({
    startDate: null,
    endDate: null,
  });
  const [payloadData, setPayloadData] = useState<any>(null);
  const [existingKeyResultsData, setExistingKeyResultsData] = useState<any[]>(
    [],
  );
  const [selectedAddedDepartment, setSelectedAddedDepartment] = useState<any[]>(
    [],
  );
  const [selectedDepartment, setSelectedDepartment] = useState<any[]>(
    selectedAddedDepartment || [],
  );
  const [selectedRole, setSelectedRole] = useState<any>([]);

  const { canEdit: canEditInitiatives, canWrite: canWriteInitiatives } =
    usePermissions(MODULES.INITIATIVES);
  const { canEdit: canEditObjectives, canWrite: canWriteObjectives } =
    usePermissions(MODULES.OBJECTIVES);
  const { canEdit: canEditKeyResults, canWrite: canWriteKeyResults } =
    usePermissions(MODULES.KEY_RESULTS);

  useEffect(() => {
    setMainDepartmentList(
      departmentsList?.map((dept: any) => ({
        color: subDepartmentList?.find((d: any) =>
          d.id.includes(dept.departmentId),
        )?.color,
        text: dept?.departmentName,
        id: dept?.departmentId,
        employeeId: dept?.employeeId,
      })) || [],
    );
  }, [departmentsList]);

  const handleDepartmentSelection = (role: any) => {
    if(selectedDepartment?.length){
        const isDepartmentOwner = selectedDepartment?.find((dept: any) => dept?.id === role?.departmentId);
        if(isDepartmentOwner){
          return true;
        }else{ 
          return  false;
        }
    }else {
        return false;
    }
  };

  useEffect(() => {
    const payload = {
      title: detailsData?.name,
      threshold: Number(detailsData?.threshold) || 0,
      departmentIds: selectedAddedDepartment?.length
        ? selectedAddedDepartment?.map((dept: any) => dept?.id)
        : [],
      owners: selectedAddedRole?.length
        ? selectedAddedRole?.map((role: any) => {
            return {
              ownerId: role?.id,
              role: role?.role || "Owner",
              isDepartmentOwner: handleDepartmentSelection(role)
            };
          })
        : [
            {
              ownerId: userID,
              role: "Owner",
              isDepartmentOwner: false,
            },
          ],
      startDate: timelineData?.startDate ? dayjs(timelineData?.startDate) : "",
      endDate: timelineData?.endDate ? dayjs(timelineData?.endDate) : "",
      weightage: Number(detailsData?.weightage) || 0,
      status: detailsData?.status || "Not Started",
      description: description,
      createdBy: userID,
      objectives: listKeyResultsData?.map((keyResult: any) => ({
        objectiveId: keyResult?.objectiveId,
        keyResultId: keyResult?.id,
        weightage: Number.parseFloat(keyResult?.weightage) || 0,
      })),
    };
    setPayloadData(payload);
  }, [
    newObjectiveData,
    detailsData,
    description,
    selectedAddedRole,
    timelineData,
    selectedAddedDepartment,
    objectiveId,
    keyResultId,
    listKeyResultsData,
    selectedRole,
    selectedDepartment
  ]);

  useEffect(() => {
    setSelectedDepartment(selectedAddedDepartment || []);
  }, [selectedAddedDepartment]);

  const handleCreateInitiative = async (action: any, payload: any) => {
    setLoading(true);
    try {
      // Normalize dates to YYYY-MM-DD as required by API
      const normalizedPayload = {
        ...payload,
        startDate: dayjs(payload?.startDate || dayjs()).format("YYYY-MM-DD"),
        endDate: dayjs(payload?.endDate || dayjs()).format("YYYY-MM-DD"),
      };
      const response = await (initiativeId
        ? updateInitiative(initiativeId, normalizedPayload)
        : addInitiative(normalizedPayload));
      setInitiativeId(response?.data?.data?.initiativeId);
      fetchInitiatives();
      fetchInitiativeById(response?.data?.data?.initiativeId);
      fetchAllMilestones();
      action(false);
      if (initiativeId) {
        setAlertMessage("Initiative updated successfully");
      } else {
        setAlertMessage("Initiative created successfully");
      }
      setAlertType("success");
      setAlertOpen(true);
      setLoading(false);
    } catch (error: any) {
      setAlertMessage(
        error?.response?.data?.message || "Failed to create Initiative",
      );
      setAlertType("error");
      setAlertOpen(true);
      setLoading(false);
    }
  };

  const fetchKeyResults = async () => {
    setKeyResultsLoading(true);
    try {
      const res = await getKeyResults();
      const mappedKeyResults = (res.data.data || []).map((keyres: any) => ({
        id: keyres.pk,
        title: keyres.title,
        isActive: keyres.isActive,
        description: keyres.description,
        progress: keyres.progress,
        status: keyres.status,
        initiativeCount: keyres.initiativeCount,
        objectiveCount: keyres.objectiveCount,
        objectiveId: keyres.objectiveId,
      }));
      setExistingKeyResultsData(mappedKeyResults);
      setKeyResultsLoading(false);
    } catch {
      setKeyResultsLoading(false);
    }
  };

  // Fetch milestones for the initiative
  const fetchAllMilestones = async () => {
    if (!initiativeId) return;
    setLoading(true);
    try {
      const response = await getAllMilestones({
        initiativeId: initiativeId,
        statusNames: ["Created", "Missed"],
      });
      if (response?.data?.data?.length > 0) {
        setMilestonesData(
          response.data.data?.map((item: any) => ({
            id: item?.milestoneId,
            milestone: item?.milestoneTitle,
            department: (
              <Department
                key={item?.departmentResponse?.departmentId}
                departmentId={item?.departmentResponse?.departmentId}
                departmentName={item?.departmentResponse?.departmentName || "-"}
              />
            ),
            date: item?.endDate
              ? dayjs(item.endDate).format("MM-DD-YYYY")
              : "-",
            status: (
              <Status
                status={item?.statusResponse?.statusName}
                isDisabled={item?.isApprovalPending}
              />
            ),
            data: item,
            isFaded: item?.isDisable || false,
          })),
        );
        setAlertMessage("Milestones fetched successfully");
        setAlertType("success");
      }
      setAlertOpen(true);
      setLoading(false);
    } catch (error: any) {
      if (error?.response?.status === 404) {
        setMilestonesData([]);
      } else {
        setAlertMessage("Failed to fetch disposition");
      }
      setAlertType("error");
      setAlertOpen(true);
      setLoading(false);
    }
  };

  // Check if department has cleared milestones
  const checkDepartmentHasClearedMilestones = (
    departmentId: number,
  ): boolean => {
    return clearedMilestonesData.some((milestone: any) => {
      const milestoneDepId = milestone?.departmentId;

      return milestoneDepId === departmentId; //&& milestoneStatus === "cleared";
    });
  };

  // Function to refresh milestone data
  const refreshMilestoneData = async () => {
    if (!initiativeId) return;

    try {
      const response = await getAllMilestones({
        initiativeId: initiativeId,
        statusNames: ["Created", "Missed"], // Fetch only cleared milestones for validation
      });

      if (response?.data?.data?.length > 0) {
        setMilestonesData(
          response.data.data?.map((item: any) => ({
            id: item?.milestoneId,
            milestone: item?.milestoneTitle,
            department: (
              <Department
                key={item?.departmentResponse?.departmentId}
                departmentId={item?.departmentResponse?.departmentId}
                departmentName={item?.departmentResponse?.departmentName || "-"}
              />
            ),
            date: item?.startDate
              ? dayjs(item.startDate).format("MM-DD-YYYY")
              : "-",
            status: (
              <Status
                status={item?.statusResponse?.statusName}
                isDisabled={item?.isApprovalPending}
              />
            ),
            data: item,
            isFaded: item?.isDisable || false,
          })),
        );
      } else {
        setMilestonesData([]);
      }
    } catch {
      setMilestonesData([]);
    }
  };

  // Handle department removal with validation
  const handleDepartmentRemoval = async (department: any) => {
    const departmentId = department?.id || department;

    if (initiativeId && checkDepartmentHasClearedMilestones(departmentId)) {
      setAlertMessage(
        "You can't delete this department as it has cleared milestones.",
      );
      setAlertType("error");
      setAlertOpen(true);
      return false;
    }

    // Allow removal if no cleared milestones
    setSelectedAddedDepartment((prev) =>
      prev.filter((dept) => dept.id !== department.id),
    );

    // Refresh milestone data after successful removal
    await refreshMilestoneData();

    return true;
  };

  const updateInitiativeById = async () => {
    if (keyResultId && initiativeId) {
      fetchInitiativeById(initiativeId);
    }
  };

  useEffect(() => {
    if (initiativeAPIData) {
      setDetailsData({
        name: initiativeAPIData?.title || "",
        lastUpdated:
          dayjs(initiativeAPIData?.updatedAt).format(dateFormat) || null,
        progress: initiativeAPIData?.progress || 0,
        weightage: initiativeAPIData?.weightage || 0,
        threshold: initiativeAPIData?.threshold || 0,
        actualReportedPercentage:
          initiativeAPIData?.actualReportedPercentage || 0,
        mileStonePercentage: initiativeAPIData?.mileStonePercentage || 0,
        status: initiativeAPIData?.status || "Not Started",
      });
      setDescription(initiativeAPIData?.description || "");
      setTimelineData({
        startDate: initiativeAPIData?.startDate
          ? moment(initiativeAPIData?.startDate, dateFormat)?.format(dateFormat)
          : null,
        endDate: initiativeAPIData?.endDate
          ? moment(initiativeAPIData?.endDate, dateFormat)?.format(dateFormat)
          : null,
      });
      setSelectedAddedRole(
        initiativeAPIData?.owners?.map((id: any) => {
          const emp = employeesList.find(
            (emp: any) => emp?.employeeId === id?.ownerId,
          );
          return emp
            ? {
                id: emp.employeeId,
                name: emp.employeeFullName,
                label: emp.employeeFullName,
                profileImage: emp.employeeImage || ownerImage,
                departmentId: emp.departmentId,
                departmentName: emp.departmentName,
                roles:
                  emp.roles?.map((r: any) => ({
                    id: r.roleId,
                    name: r.roleName,
                  })) || [],
                role: id?.roleName,
                roleId: emp.roles?.[0]?.roleId || null,
              }
            : null;
        }) || [],
      );
      setSelectedRole(
        initiativeAPIData?.owners?.map((id: any) => {
          const emp = employeesList.find(
            (emp: any) => emp?.employeeId === id?.ownerId,
          );
          return emp
            ? {
                id: emp.employeeId,
                name: emp.employeeFullName,
                label: emp.employeeFullName,
                profileImage: emp.employeeImage || ownerImage,
                departmentId: emp.departmentId,
                departmentName: emp.departmentName,
                roles:
                  emp.roles?.map((r: any) => ({
                    id: r.roleId,
                    name: r.roleName,
                  })) || [],
                role: id?.roleName || "Owner",
                roleId: emp.roles?.[0]?.roleId || null,
              }
            : null;
        }) || [],
      );
      setSelectedAddedDepartment(
        initiativeAPIData?.departments?.map((id: any) =>
          mainDepartmentList.find((dept: any) => dept?.id === id?.departmentId),
        ) || [],
      );
      setNewObjectiveData(
        initiativeAPIData?.objectives?.map((obj: any) => ({
          objectiveName: obj?.objectiveTitle || "",
          startDate: dayjs(obj?.lastUpdated).format(dateFormat) || "",
          weightage: obj?.progressPercentage || 0,
          objectiveId: obj?.objectiveId || null,
          status: obj?.status || "Not Started",
        })),
      );
      setKeyResultId(initiativeAPIData?.keyResults?.[0]?.keyResultId || null);
    }
  }, [initiativeAPIData, initiativeAPIData?.startDate, mainDepartmentList]);

  // Fetch milestones when initiativeId changes
  useEffect(() => {
    if (initiativeId && keyResultId && objectiveId) {
      fetchAllMilestones();
    }
    const viewport = osRef.current?.osInstance()?.elements().viewport;
    viewport?.scrollTo({ top: 0, behavior: "smooth" });
  }, [initiativeId, keyResultId, objectiveId]);

  // }, [initiativeAPIData]);

  const showLoading = useMemo(
    () => loading || keyResultsLoading,
    [loading, keyResultsLoading],
  );
  useSetLoading(showLoading);

  return (
    <div className="company-dashboard-initiative-drawer-side-bar">
      <OverlayScrollbarsComponent
        className="company-dashboard-initiative-drawer-side-bar-content"
        ref={osRef}
        options={{
          scrollbars: {
            autoHide: "scroll",
            clickScroll: false,
            dragScroll: true,
            autoHideDelay: 0,
          },
        }}
      >
        <div
          className={`company-dashboard-initiative-drawer-side-bar-content-header-close-arrow ${listKeyResultsData?.length === 0 ? "not-allowed-section" : ""}`}
        >
          <div className="company-dashboard-initiative-drawer-side-bar-content-header-close">
            Overview
          </div>
          <div className="company-dashboard-initiative-drawer-side-bar-content-close-arrow">
            <Tooltip title={keyResultIdTooltip}>
              <button
                style={{
                  background: "none",
                  border: "none",
                  padding: 0,
                  margin: 0,
                  cursor: listKeyResultsData?.length ? "pointer" : "not-allowed",
                }}
                onClick={() =>
                  listKeyResultsData?.length
                    ? setIsAccordion(!isAccordion)
                    : null
                }
              >
              <i
                className={`fa ${
                  isAccordion ? "fa-chevron-up" : "fa-chevron-down"
                }`}
              />
              </button>
            </Tooltip>
          </div>
        </div>
        {isAccordion ? (
          <OverlayScrollbarsComponent
            className={`company-dashboard-initiative-drawer-side-bar-content-inner ${listKeyResultsData?.length === 0 && !initiativeId ? "not-allowed-section" : ""}`}
            options={{
              scrollbars: {
                autoHide: "scroll",
                clickScroll: false,
                dragScroll: true,
                autoHideDelay: 0,
              },
            }}
          >
            <div
              style={
                listKeyResultsData?.length === 0 && !initiativeId
                  ? {
                      pointerEvents: "none",
                    }
                  : {}
              }
            >
              <CompanyDashboardInitiativeDrawerSideBarName
                detailsData={detailsData}
                setInitiativeId={setInitiativeId}
                handleCreateInitiative={handleCreateInitiative}
                initiativeId={initiativeId}
                setDetailsData={setDetailsData}
                payloadData={payloadData}
                canEdit={canEditInitiatives}
                listKeyResultsData={listKeyResultsData}
                statusListInitiatives={statusListInitiatives}
                initiativeDataPermissions={initiativeDataPermissions}
              />
            </div>

            <div className={`${initiativeId ? "" : "not-allowed-section"}`}>
              <CompanyDashboardInitiativeDrawerSideBarDescription
                description={description}
                setDescription={setDescription}
                initiativeId={initiativeId}
                initiativeIdTooltip={initiativeIdTooltip}
                handleCreateInitiative={handleCreateInitiative}
                payloadData={payloadData}
                canEdit={canEditInitiatives}
                canWrite={canWriteInitiatives}
                initiativeDataPermissions={initiativeDataPermissions}
              />
              <CompanyDashboardInitiativeDrawerSideBarDepartment
                selectedAddedDepartment={selectedAddedDepartment}
                setSelectedAddedDepartment={setSelectedAddedDepartment}
                selectedDepartment={selectedDepartment}
                setSelectedDepartment={setSelectedDepartment}
                initiativeId={initiativeId}
                initiativeIdTooltip={initiativeIdTooltip}
                mainDepartmentList={mainDepartmentList}
                handleCreateInitiative={handleCreateInitiative}
                payloadData={payloadData}
                canEdit={canEditInitiatives}
                canWrite={canWriteInitiatives}
                handleDepartmentRemoval={handleDepartmentRemoval}
                initiativeDataPermissions={initiativeDataPermissions}
                selectedRole={selectedRole}
                setSelectedRole={setSelectedRole}
                selectedAddedRole={selectedAddedRole}
                setSelectedAddedRole={setSelectedAddedRole}
                employeesList={employeesList}
                fetchInitiativeById={fetchInitiativeById}
              />
              <CompanyDashboardInitiativeDrawerSideBarTimeline
                timelineData={timelineData}
                setTimelineData={setTimelineData}
                initiativeId={initiativeId}
                initiativeIdTooltip={initiativeIdTooltip}
                handleCreateInitiative={handleCreateInitiative}
                payloadData={payloadData}
                canEdit={canEditInitiatives}
                canWrite={canWriteInitiatives}
                dateFormat={dateFormat}
                initiativeDataPermissions={initiativeDataPermissions}
              />
              <CompanyDashboardInitiativeDrawerSideBarRole
                employeesList={employeesList}
                selectedAddedRole={selectedAddedRole}
                setSelectedAddedRole={setSelectedAddedRole}
                initiativeId={initiativeId}
                initiativeIdTooltip={initiativeIdTooltip}
                handleCreateInitiative={handleCreateInitiative}
                payloadData={payloadData}
                canEdit={canEditInitiatives}
                canWrite={canWriteInitiatives}
                initiativeDataPermissions={initiativeDataPermissions}
                selectedDepartment={selectedDepartment}
                setSelectedDepartment={setSelectedDepartment}
                selectedRole={selectedRole}
                setSelectedRole={setSelectedRole}
                setSelectedAddedDepartment={setSelectedAddedDepartment}
                selectedAddedDepartment={selectedAddedDepartment}
                mainDepartmentList={mainDepartmentList}
              />
            </div>
          </OverlayScrollbarsComponent>
        ) : null}
        <div className="company-dashboard-initiative-drawer-side-bar-content-inner-tab-content">
          <div className="company-dashboard-initiative-drawer-side-bar-content-inner-tab-action">
            <div
              className={`company-dashboard-initiative-drawer-side-bar-content-inner-tab-action-button ${isActiveTab ? "" : activeTabClassName}`}
              style={{ cursor: "pointer", height: "24px", }}
            >
            <button
              style={{
                background: "none",
                border: "none",
                padding: 0,
                margin: 0,
                cursor: "pointer",
                color: `${isActiveTab ? "#403C6F" : ""}`,
              }}
              onClick={() => setIsActiveTab(false)}
              className={`${isActiveTab ? "" : activeTabClassName}`}
            >
              Key Results
              <IconButton
                sx={{
                  border: "1px solid  #CFCEDA",
                  width: 24,
                  height: 24,
                  borderRadius: "50%",
                  fontSize: "16px",
                  color: "#403C6F",
                  marginLeft: "8px",
                  backgroundColor: " #FFFFFF",
                }}
              >
                {listKeyResultsData?.length || 0}
              </IconButton>
              </button>
            </div>
            <div
              className={`company-dashboard-initiative-drawer-side-bar-content-inner-tab-action-button ${isActiveTab ? activeTabClassName : ""}`}
              style={{ cursor: "pointer", height: "24px", }}
            >
            <button
              style={{
                background: "none",
                border: "none",
                padding: 0,
                margin: 0,
                cursor: "pointer",
                color: `${isActiveTab ? "" : "#403C6F"}`,
              }}
              onClick={() => setIsActiveTab(true)}
              className={`${isActiveTab ? activeTabClassName : ""}`}
            >
              Objectives
              <IconButton
                sx={{
                  border: "1px solid  #CFCEDA",
                  width: 24,
                  height: 24,
                  borderRadius: "50%",
                  fontSize: "16px",
                  color: "#403C6F",
                  marginLeft: "8px",
                  backgroundColor: " #FFFFFF",
                }}
              >
                {newObjectiveData?.length || 0}
              </IconButton>
              </button>
            </div>
          </div>
          <div className="company-dashboard-initiative-drawer-side-bar-content-inner-tab-content">
            {isActiveTab ? (
              <CompanyDashboardInitiativeDrawerSideBarObjectives
                employeesList={employeesList}
                objectiveId={objectiveId}
                setObjectiveId={setObjectiveId}
                newObjectiveData={newObjectiveData}
                setNewObjectiveData={setNewObjectiveData}
                statusListObjectives={statusListObjectives}
                fetchInitiatives={fetchInitiatives}
                setAlertType={setAlertType}
                setAlertOpen={setAlertOpen}
                setLoading={setLoading}
                setAlertMessage={setAlertMessage}
                initiativeAPIData={initiativeAPIData}
                updateInitiativeById={updateInitiativeById}
                canEdit={canEditObjectives}
                canWrite={canWriteObjectives}
                setObjective={setObjective}
                setIsShowInitiativeDrawer={setIsShowInitiativeDrawer}
                setIsShowAddAllObjectiveDrawer={setIsShowAddAllObjectiveDrawer}
                initiativeDataPermissions={initiativeDataPermissions}
                initiativeId={initiativeId}
              />
            ) : (
              <div>
                <CompanyDashboardInitiativeDrawerSideBarKeyResults
                  employeesList={employeesList}
                  keyResultId={keyResultId}
                  setKeyResultId={setKeyResultId}
                  setIsAccordion={setIsAccordion}
                  objectiveIdTooltip={objectiveIdTooltip}
                  objectiveId={objectiveId}
                  setObjectiveId={setObjectiveId}
                  statusListObjectives={statusListObjectives}
                  fetchInitiatives={fetchInitiatives}
                  setAlertType={setAlertType}
                  setAlertOpen={setAlertOpen}
                  setLoading={setLoading}
                  setAlertMessage={setAlertMessage}
                  statusListKeyResults={statusListKeyResults}
                  initiativeAPIData={initiativeAPIData}
                  updateInitiativeById={updateInitiativeById}
                  canEdit={canEditKeyResults}
                  canWrite={canWriteKeyResults}
                  canWriteInitiatives={canWriteInitiatives}
                  fetchInitiativeById={fetchInitiativeById}
                  listKeyResultsData={listKeyResultsData}
                  setListKeyResultsData={setListKeyResultsData}
                  dateFormat={dateFormat}
                  setNewObjectiveData={setNewObjectiveData}
                  existingKeyResultsData={existingKeyResultsData}
                  fetchKeyResults={fetchKeyResults}
                  handleCreateInitiative={handleCreateInitiative}
                  initiativeId={initiativeId}
                  payloadData={payloadData}
                  initiativeDataPermissions={initiativeDataPermissions}
                />
              </div>
            )}
          </div>
        </div>
      </OverlayScrollbarsComponent>
    </div>
  );
};

export default CompanyDashboardInitiativeDrawerSideBar;
